import React from "react"
import Icon from "../icon/icon.component"
import {EllipsisMenuProps} from "../types/dropdown"

export const DropdownEllipsisMenu = (props: EllipsisMenuProps) => {
    return (
        <>
            <button
                className="btn btn-sm btn-outline-primary mr-2"
                type="button" id="dropdownMoreButton"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false">
                <Icon value={"ellipsis-h"} className={"mr-1"}/>
            </button>

            <div className="dropdown-menu" aria-labelledby="dropdownMoreButton">

                {props.items?.map((item, index) => {
                    return (
                        <a key={index} className={`dropdown-item ${item.className ? item.className : ""}`} href="#" onClick={item.onClickCallback}>
                            {item.children}
                        </a>
                    )
                })}
            </div>

        </>
    )
}


// WEBPACK FOOTER //
// ./src/common/dropdown/DropdownEllipsisMenu.tsx